var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.2469 13.3447L53.8727 9.02631L50.0544 0H35L30.0941 45.0153L35 70H63.2469V61.6127L58.9199 46.4242L63.2469 30.6094V13.3447Z",
    fill: "#C6E1E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4669 0V21.9611L11.6211 42.7465L15.4669 59.5715V70H35V0L15.4669 0Z",
    fill: "#EEF5F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2469 30.6094H35L30.0941 46.2967L35 61.6127H63.2469V30.6094Z",
    fill: "#2E8AE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0544 13.3447H63.2469C59.3749 9.4727 53.9264 3.87201 50.0544 0V13.3447Z",
    fill: "#A6D1D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4669 30.6094L6.75323 26.1249V54.5851C6.75323 58.4662 9.88286 61.6126 13.7435 61.6126H35V48.3779L33.403 44.5614L35 39.3953V30.6094H15.4669Z",
    fill: "#4DA6FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4669 30.6094H11.0659C8.68411 30.6094 6.75323 28.6785 6.75323 26.2967V26.2738C6.75323 23.892 8.68411 21.9611 11.0659 21.9611H15.4669V30.6094Z",
    fill: "#2E8AE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4395 50.3705H51.4746V37.7446H47.373V54.472H55.4395V50.3705Z",
    fill: "#0A1F33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7129 54.472C24.1053 54.472 26.8652 51.7121 26.8652 48.3197V37.7446H22.7637V48.3197C22.7637 49.4505 21.8437 50.3705 20.7129 50.3705C19.5821 50.3705 18.6621 49.4505 18.6621 48.3197V37.7446H14.5605V48.3197C14.5605 51.7121 17.3205 54.472 20.7129 54.472Z",
    fill: "#143D66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1834 48.4482C42.4217 47.3221 43.2001 45.6987 43.2001 43.897C43.2001 40.5046 40.4402 37.7446 37.0478 37.7446H35L34.1012 39.7677L35 41.8462H37.0479C38.1787 41.8462 39.0987 42.7662 39.0987 43.897C39.0987 45.0278 38.1787 45.9478 37.0479 45.9478H35L33.8684 47.9592L35 50.0493C35 50.0493 37.2363 50.0464 37.3299 50.0422L40.1985 54.4775L43.6423 52.2499L41.1834 48.4482Z",
    fill: "#0A1F33"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41.8462V37.7446H30.8956V54.4775H35V50.0493V45.9478V41.8462Z",
    fill: "#143D66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomIcon);
export default __webpack_public_path__ + "static/media/customIcon.4ea45588be5e24e430f0ef330ee4f279.svg";
export { ForwardRef as ReactComponent };